/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import { superBoxStyle } from '@vital-ui/react-utils';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';
import FooterButton from './FooterButton';
var Root = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  margin: auto;\n  box-sizing: border-box;\n  flex-direction: column;\n  word-break: break-word;\n  border-radius: 0.25rem;\n  overflow: hidden;\n  background-color: ", ";\n  box-shadow: ", ";\n  border: ", ";\n  ", ";\n"], ["\n  position: relative;\n  display: flex;\n  margin: auto;\n  box-sizing: border-box;\n  flex-direction: column;\n  word-break: break-word;\n  border-radius: 0.25rem;\n  overflow: hidden;\n  background-color: ", ";\n  box-shadow: ",
    ";\n  border: ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.card.bg;
}, function (_a) {
    var shadow = _a.shadow;
    return shadow ? '2px 2px 4px 0px #cfd8dc' : 'none';
}, function (_a) {
    var theme = _a.theme;
    return theme.border;
}, superBoxStyle);
Root.defaultProps = {
    theme: defaultTheme,
};
/**
 * @render react
 * @name Card
 * @description Card Component with header, footer, buttons
 * @example
 *
 * <Card width="300px" height="420px">
 *   <Card.Header image={"http://react.vitaluikit.com/static/media/card-header-pic.0080a766.png"} title="Title" />
 *   <Card.Content>This is Content.</Card.Content>
 *    <Card.Footer>
 *      <Card.FooterButton>Cancel</Card.FooterButton>
 *      <Card.FooterButton primary>Confirm</Card.FooterButton>
 *    </Card.Footer>
 * </Card>
 *
 */
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.render = function () {
        var _a = this.props, children = _a.children, width = _a.width, height = _a.height, shadow = _a.shadow, className = _a.className, props = __rest(_a, ["children", "width", "height", "shadow", "className"]);
        return (React.createElement(Root, __assign({ className: cn('vital__card', className), width: width, height: height, shadow: shadow }, props), children));
    };
    Card.defaultProps = {
        width: 'auto',
        height: 'auto',
        shadow: false,
    };
    Card.Header = Header;
    Card.Content = Content;
    Card.Footer = Footer;
    Card.FooterButton = FooterButton;
    return Card;
}(React.Component));
export default Card;
var templateObject_1;
//# sourceMappingURL=Card.js.map